import axios from 'axios'

import { store } from './store'

export type Body = Record<string, unknown>

const getToken = () => store.getState().user.user.auth_token || ''

const bearerHeaders = () => ({ Authorization: `Bearer ${getToken()}` })

export const authPost = (url: string, body: Body) => axios.post(url, body, { headers: bearerHeaders() })

export const authGet = (url: string) => axios.get(url, { headers: bearerHeaders() })

export const upload = (url: string, body: FormData) => axios.post(url, body, { headers: bearerHeaders() })

export const get = (url: string) => axios.get(url)
